export const SKILLS_ICONS_ADAPTER = {
  Experience: 'Trophy',
  ExerciseYes: 'AlertSuccess',
  InjectMedsYes: 'InjectMeds',
  OralMedsYes: 'OralMeds',
  HasDogs: 'AlertSuccess',
  CprYes: 'CPR',
};

export const SitterProfileVersionOptions = {
  LEGACY: 'legacy',
  REVAMP: 'revamp',
} as const;

export const ViewerOptions = {
  SELF: 'self',
  DEFAULT: 'default',
} as const;
